export const GRADE_LEVELS = [
  'Third',
  'Fourth',
  'Fifth',
  'Sixth',
  'Seventh',
  'Eighth',
];

export const COMPETITION_LEVELS = [
  { value: 'elementary', label: 'Elementary' },
  { value: 'middle', label: 'Middle School' },
];

export const TESTS = [
  { id: 'reasoning', label: 'Reasoning' },
  { id: 'computation', label: 'Computation' },
];

/**
 * Zoho CRM subforms hold at most 100 rows, so one registration can include at
 * most this many students. Keep equal to MAX_STUDENTS_PER_SCHOOL on the API.
 */
export const MAX_STUDENTS = 100;

export function studentLimitMessage(count) {
  return `A single registration can include at most ${MAX_STUDENTS} students (you have entered ${count}). Please email SLL@acsi.org to register a larger school.`;
}

/** The only fee: a flat charge per selected student test. No school or late fees. */
export const PRICING = {
  studentFee: 20,
};

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC',
];

/** Most common registrations — pinned to the top of the Country dropdown. */
export const PRIORITY_COUNTRIES = ['United States', 'Canada', 'Mexico'];

/** Remaining countries, alphabetical. Kept as free-text-free picklist so CRM values stay consistent. */
export const OTHER_COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola',
  'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
  'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei',
  'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
  'Cameroon', 'Central African Republic', 'Chad', 'Chile', 'China',
  'Colombia', 'Comoros', 'Congo (Democratic Republic of the)',
  'Congo (Republic of the)', 'Costa Rica', 'Côte d’Ivoire', 'Croatia',
  'Cuba', 'Cyprus', 'Czechia', 'Denmark', 'Djibouti', 'Dominica',
  'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador',
  'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia',
  'Fiji', 'Finland', 'France', 'Gabon', 'Gambia',
  'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada',
  'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
  'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia',
  'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya',
  'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos',
  'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
  'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands',
  'Mauritania', 'Mauritius', 'Micronesia', 'Moldova', 'Monaco',
  'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
  'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand',
  'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia',
  'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine',
  'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines',
  'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia',
  'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino',
  'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
  'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia',
  'Solomon Islands', 'Somalia', 'South Africa', 'South Korea',
  'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname',
  'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
  'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga',
  'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom',
  'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela',
  'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe',
];

export const COUNTRIES = [...PRIORITY_COUNTRIES, ...OTHER_COUNTRIES];

export const TERMS_TEXT = `By registering your school and students for the International Math Competition (IMC), you confirm that you are authorized to act on behalf of your school and that you have obtained all necessary parent or guardian consent to (i) submit student information for participation in the competition, and (ii) release student photos or videos if such media is later provided. You agree to submit accurate and complete details, including student names, grade levels, and other relevant data, and you acknowledge that this information will be used solely for the purpose of managing registration, communication, and participation in the IMC.

All submitted information will be handled in compliance with applicable privacy laws and will not be sold or used for unrelated purposes. By completing registration, you consent to ACSI and its designated partners storing and processing student data as necessary for competition administration.

Schools may be asked to submit photos or videos of students participating in the IMC. By submitting any such media, the school represents and warrants that it has obtained all required permissions and releases from the parents or legal guardians of the students depicted. The school further agrees that, by providing such media, it indemnifies, defends, and holds harmless ACSI, its officers, directors, employees, agents, and affiliates from any and all claims, liabilities, damages, losses, or expenses (including reasonable attorneys’ fees) arising from or related to ACSI’s use of the media for promotional, advertising, marketing, or other related purposes.

The school acknowledges that it is solely responsible for securing and maintaining all necessary consents from parents or guardians and assumes all liability for failing to do so. ACSI shall not be held responsible for any disputes, claims, or legal actions arising from the school’s failure to obtain appropriate permissions.

Disclaimer and Limitation of Liability

While ACSI will use reasonable efforts to administer the IMC fairly and securely, ACSI does not guarantee uninterrupted access to competition platforms or freedom from technological errors, delays, or outages. ACSI is not responsible for technical difficulties, internet connectivity issues, data breaches despite commercially reasonable safeguards, or any other circumstances beyond its reasonable control that may affect registration, participation, scoring, or results.

In no event shall ACSI, its officers, directors, employees, agents, or affiliates be liable to any school, student, or parent/guardian for indirect, incidental, special, consequential, or punitive damages, or for any loss of data, business interruption, or reputational harm arising out of or related to participation in the IMC. ACSI’s total liability for any claim related to the IMC shall not exceed the total registration fees paid by the school for the competition.

By registering your school and students for the International Math Competition (IMC), you confirm that you are authorized to act on behalf of your school and have obtained all necessary parent or guardian consent to submit student information. You agree to provide accurate details, including student names, grade levels, and other relevant data, which will be used solely for managing registration, communication, and participation in this online competition. All submitted information will be handled in compliance with applicable privacy laws and will not be sold or used for unrelated purposes. You also consent to ACSI and its partners storing and processing this data as needed for competition administration.`;

export const CANCELLATION_TEXT = `All registration fees must be paid in full at the time of registration. Participants who cancel their registration 61 days or more prior to the scheduled testing date are eligible for a refund of 75% of the total fees paid, less any applicable processing fees. Cancellations made between 46 and 60 days before the testing date will receive a refund of 25% of the total fees paid, minus processing fees. No refunds will be issued for cancellations made 45 days or fewer before the testing date.

All cancellation requests must be submitted in writing to SLL@acsi.org. Refunds will be issued to the original method of payment and will be processed within 14 days from the date the cancellation is confirmed.`;

export const INTRO_COPY = {
  lead: 'Complete the form below to register your school for the International Math Competition hosted by ACSI’s Student Leadership and Learning Department. You will be asked to provide information about your school and the students who will compete, so please have your student data ready at the time of registration.',
  support:
    'For assistance with registration, email SLL@acsi.org or call (800) 367.0798.',
  acsiHelp:
    'Schools can find their ACSI ID in their ACSI account or by emailing careteam@acsi.org.',
  schoolCodeHelp:
    'Please create a unique 3–5 letter code to represent your school. This code must contain only letters and will be used to generate student accounts.',
};

export const DRAFT_STORAGE_KEY = 'imc_school_registration_draft';

export const STUDENT_TEMPLATE_HEADERS = [
  "Student's First Name",
  "Student's Last Name",
  'Grade Level',
  'Tests',
];

export function createId() {
  return `id_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 9)}`;
}

export function createEmptyContact() {
  return {
    id: createId(),
    firstName: '',
    lastName: '',
    title: '',
    phone: '',
    email: '',
  };
}

export function createEmptyStudent() {
  return {
    id: createId(),
    firstName: '',
    lastName: '',
    gradeLevel: '',
    tests: {
      reasoning: false,
      computation: false,
    },
  };
}

export function createInitialFormState() {
  return {
    school: {
      name: '',
      acsiId: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: 'United States',
      schoolCode: '',
    },
    contacts: [createEmptyContact()],
    registrationMethod: 'manual',
    totalTestCount: '',
    registeringStudents: 'yes',
    competitionLevel: '',
    students: [createEmptyStudent()],
    acceptTerms: false,
    acceptCancellation: false,
  };
}
